
import React, { useState } from 'react';
import { AppBar, Tabs, Tab } from '@mui/material';
import EditarActivo from "./EditarActivo.js";
import CriticidadActivos from './CriticidadActivos';
// import CriticidadAgregada from './CriticidadAgregada';
import ResumenActivos from './ResumeActivos.js';

const MainActivosInformacion = ({ params }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position="static" style={{ backgroundColor: '#2c2a29' }}>
                <Tabs value={value} onChange={handleChange} textColor="inherit" indicatorColor="secondary">
                    <Tab label="Editar Activos" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    <Tab label="Criticidad" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    {/* <Tab label="Criticidad Detalles" style={{ color: "#ffffff", padding: "3px 7px 3px" }} /> */}
                </Tabs>
            </AppBar>

            {value === 0 && <EditarActivo params={params} />}
            {value === 1 && <CriticidadActivos params={params} />}
            {/* {value === 2 && <CriticidadAgregada params={params} />} */}
        </div>
    );
};

export default MainActivosInformacion;

